import { render, staticRenderFns } from "./AuthenticatorForm.vue?vue&type=template&id=c1132a64&"
import script from "./AuthenticatorForm.vue?vue&type=script&lang=js&"
export * from "./AuthenticatorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports